import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import Cookies from 'js-cookie';
import router from "../router.js";

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        pageTitle: '',
        products: [],
        testString: 'teststring',
        defaultColor:'#547dbf',
        auth: false,
        currentUser: {
            id: null,
            username: null, 
            name: null,
            surname : null,
            email: null,
            role: null, 
            token: null, 
            refid: null,

            first_name: '',
            last_name: '',
            date_of_birth: '',
            phone: '',
            address: '',
            zip: '',   
            city: '',
            country: '',
            account_name: '',
            account_number: '',
            account_signatory_person: '',
            swift: '',
            bic: '',
            iban: '',
            selected_package: null,
            company: 0,
            company_name: '',
            left_id: 0,
            right_id: 0,
            rotation_left: 0,
            rotation_right: 0,
            payment_type:'',
        },
        errorDialog: false,
        dialog: {
            show: false,
            header: 'Header',
            redirect: 'profile',
            message: 'Test message'
        },
        errorDialogMsg: 'Something went wrong'
    },
    modules: {
    },
    actions: {
        validateUser() {
            // api check
            // commit('logIn', response)
        }
    },
    mutations: {
        logIn(state, user) {
            state.currentUser.id = user.id
            
            state.currentUser.name = user.name
            state.currentUser.surname = user.surname
            state.currentUser.role = user.role
            state.currentUser.email = user.email
            state.currentUser.token = user.token
            state.currentUser.refid = user.refid
            state.auth = true;

            state.currentUser.username = user.username
            state.currentUser.first_name = user.name
            state.currentUser.last_name = user.surname
            state.currentUser.date_of_birth = user.date_of_birth
            state.currentUser.phone = user.phone
            state.currentUser.address = user.address
            state.currentUser.zip = user.zip
            state.currentUser.city = user.city
            state.currentUser.country = user.country
            state.currentUser.account_name = user.account_name
            state.currentUser.account_number = user.account_number
            state.currentUser.account_signatory_person = user.account_signatory_person
            state.currentUser.swift = user.swift
            state.currentUser.bic = user.bic
            state.currentUser.iban = user.iban
            state.currentUser.btc_wallet = user.btc_wallet

            state.currentUser.bank_name = user.bank_name
            state.currentUser.bank_address = user.bank_address
            state.currentUser.bank_zip = user.bank_zip
            state.currentUser.bank_city = user.bank_city
            state.currentUser.bank_country = user.bank_country

            state.currentUser.company = user.company
            state.currentUser.company_id = user.company_id
            state.currentUser.company_name = user.company_name

            state.currentUser.left_id = user.left_id;
            state.currentUser.right_id = user.right_id;
            state.currentUser.rotation_left = user.rotation_left;
            state.currentUser.rotation_right = user.rotation_right;
            state.currentUser.payment_type = user.payment_type;

            switch (state.currentUser.role) {
                case 'admin':
                    router.push('/admin')
                    break;

                case 'customer':
                    router.push('/user/shop')
                    break;
            
                default:
                    router.push('/user/overview')
                    break;
            }
        },
        updatePersonalData(state, data) {
            state.currentUser.username = data.username
            state.currentUser.first_name = data.first_name
            state.currentUser.last_name = data.last_name
            state.currentUser.date_of_birth = data.date_of_birth
            state.currentUser.phone = data.phone
            state.currentUser.address = data.address
            state.currentUser.zip = data.zip
            state.currentUser.city = data.city
            state.currentUser.country = data.country
        },
        updateFinancialData(state, data) {
            state.currentUser.account_name = data.account_name
            state.currentUser.account_number = data.account_number
            state.currentUser.account_signatory_person = data.account_signatory_person
            state.currentUser.swift = data.swift
            state.currentUser.bic = data.bic
            state.currentUser.iban = data.iban
            state.currentUser.btc_wallet = data.btc_wallet
            state.currentUser.bank_name = data.name
            state.currentUser.bank_address = data.address
            state.currentUser.bank_zip = data.zip
            state.currentUser.bank_city = data.city
            state.currentUser.bank_country = data.country
            state.currentUser.payment_type=data.payment_type
        },
        updateSelectedPackage(state, data) {
            state.currentUser.selected_package = data
        },
        logOut(state) {
            state.currentUser.username = null
            state.currentUser.id = null
            state.currentUser.name = null
            state.currentUser.role = null
            state.currentUser.surname = null
            state.currentUser.email = null
            state.currentUser.token = null
            state.currentUser.refid = null
            state.auth = false;

            router.push('/login')
        },
        closeErrorDialog(state) {
            state.errorDialog = false
        },
        openErrorDialog(state) {
            state.errorDialog = true
        },
        setErrorDialogMsg(state, msg) {
            state.errorDialogMsg = msg
        },
        openDialog(state, message) {
            state.dialog.show = true
            state.dialog.header = message.header
            state.dialog.message = message.body
            state.dialog.redirect = message.redirect
        },
        closeDialog(state) {
            state.dialog.show = false
        },
        setPageTitle(state, payload) {
            state.pageTitle = payload.pageTitle;
        }

    },
    plugins: [createPersistedState({
        storage: {
            getItem: key => Cookies.get(key),
            setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: false }),
            removeItem: key => Cookies.remove(key)
        }
    })],
    strict: debug
})